import { apiClient, type SiteEntity } from '@/libs/api'

export type FetchSitesByDcIdQuery = {
  tenantKey: string
  dcId: number
}

export type FetchSitesByDcIdResponse = {
  data: SiteEntity[]
}

export const fetchSitesByDcId = async (
  { tenantKey, dcId }: FetchSitesByDcIdQuery,
  signal?: AbortSignal
): Promise<FetchSitesByDcIdResponse> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .dcs._dcId(dcId)
    .sites.$get({
      config: {
        signal
      }
    })
  return {
    data
  }
}
